import type { ListBuilderConfiguration } from '../types';

/**
 * Item Purchased Together Embedded list configuration
 * Shows items frequently purchased together with a specific item
 * Converted from JSON to TypeScript for type safety
 */
export const ITEM_PURCHASED_TOGETHER_EMBEDDED_CONFIG: ListBuilderConfiguration =
	{
		filters: {
			activeFilters: [],
			defaultFilters: {},
		},
		lists: [
			{
				id: 'default-item-purchased-together-embedded',
				name: 'Frequently Purchased Together',
				type: 'default',
				active: true,
				columns: [
					{
						id: 'image',
						fields: [
							{
								id: 'image-field',
								dataConfig: {
									type: 'field',
									field: {
										fieldName: 'targetItemPrimaryImageUrl',
										objectTable: 'item',
									},
								},
								styleConfig: {
									size: 'sm',
									colorRule: { type: 'default' },
									imageOptions: {
										size: 'small',
										enableViewer: true,
									},
								},
								displayStyle: 'image',
							},
						],
						headers: [{ id: 'image-header', text: '' }],
						sortable: false,
						alignment: 'center',
						widthConfig: { mode: 'fixed', preset: 'xsmall' },
						verticalAlignment: 'middle',
					},
					{
						id: 'item-info',
						fields: [
							{
								id: 'item-description-field',
								link: {
									type: 'object',
									enabled: true,
									idField: 'targetItemId',
									objectTable: 'item',
								},
								dataConfig: {
									type: 'field',
									field: {
										fieldName: 'targetItemDescription',
										objectTable: 'item',
									},
								},
								styleConfig: {
									size: 'sm',
									colorRule: {
										type: 'static',
										staticColor: { text: '#3b82f6' },
									},
								},
								displayStyle: 'text',
							},
							{
								id: 'line-break-1',
								dataConfig: { type: 'custom_text', customText: '' },
								styleConfig: {
									size: 'md',
									colorRule: { type: 'default' },
								},
								displayStyle: 'line_break',
							},
							{
								id: 'item-manufacturer-field',
								dataConfig: {
									type: 'field',
									field: {
										fieldName: 'targetItemManufacturer',
										objectTable: 'item',
									},
								},
								styleConfig: {
									size: 'xs',
									colorRule: { type: 'theme', themeColor: 'textSecondary' },
								},
								displayStyle: 'text',
							},
							{
								id: 'line-break-2',
								dataConfig: { type: 'custom_text', customText: '' },
								styleConfig: {
									size: 'md',
									colorRule: { type: 'default' },
								},
								displayStyle: 'line_break',
							},
							{
								id: 'item-external-id-field',
								dataConfig: {
									type: 'field',
									field: {
										fieldName: 'targetItemExternalId',
										objectTable: 'item',
									},
								},
								styleConfig: {
									size: 'xs',
									colorRule: { type: 'theme', themeColor: 'textSecondary' },
								},
								displayStyle: 'text',
							},
						],
						headers: [{ id: 'item-info-header', text: 'Item' }],
						sortable: false,
						alignment: 'left',
						widthConfig: { mode: 'fixed', preset: 'medium' },
						minWidth: 200,
						verticalAlignment: 'middle',
					},
					{
						id: 'category',
						fields: [
							{
								id: 'category-field',
								dataConfig: {
									type: 'field',
									field: {
										fieldName: 'targetItemCategory',
										objectTable: 'item',
									},
								},
								styleConfig: {
									size: 'sm',
									colorRule: { type: 'default' },
								},
								displayStyle: 'text',
							},
						],
						headers: [{ id: 'category-header', text: 'Category' }],
						sortable: false,
						alignment: 'left',
						widthConfig: { mode: 'fixed', preset: 'medium' },
						verticalAlignment: 'middle',
					},
					{
						id: 'price',
						fields: [
							{
								id: 'price-field',
								dataConfig: {
									type: 'field',
									field: { fieldName: 'targetItemPrice', objectTable: 'item' },
								},
								styleConfig: {
									size: 'sm',
									colorRule: { type: 'default' },
								},
								displayStyle: 'currency',
							},
						],
						headers: [{ id: 'price-header', text: 'Price' }],
						sortable: false,
						alignment: 'left',
						widthConfig: { mode: 'fixed', preset: 'small' },
						verticalAlignment: 'middle',
					},
					{
						id: 'recommendation',
						fields: [
							{
								id: 'co-occurrence-field',
								dataConfig: {
									type: 'field',
									field: {
										fieldName: 'coOccurrenceCount',
										objectTable: 'item',
									},
								},
								styleConfig: {
									size: 'sm',
									colorRule: { type: 'default' },
									formatOptions: { decimalPlaces: 0 },
								},
								displayStyle: 'number',
							},
						],
						headers: [{ id: 'co-occurrence-header', text: 'Orders' }],
						sortable: false,
						alignment: 'left',
						widthConfig: { mode: 'fixed', preset: 'small' },
						verticalAlignment: 'middle',
					},
				],
				defaultSortId: 'recommendation-desc',
				sortOrder: 0,
			},
		],
		paging: {
			defaultPageSize: 25,
			pageSizeOptions: [25, 50],
		},
		tableSorts: [
			{
				id: 'recommendation',
				name: 'Recommendation',
				fields: [
					{
						fieldName: 'lift',
						objectTable: 'item',
						direction: 'DESC',
					},
				],
			},
			{
				id: 'name',
				name: 'Item Name',
				fields: [
					{
						fieldName: 'targetItemDescription',
						objectTable: 'item',
						direction: 'ASC',
					},
				],
			},
			{
				id: 'price',
				name: 'Price',
				fields: [
					{
						fieldName: 'targetItemPrice',
						objectTable: 'item',
						direction: 'DESC',
					},
				],
			},
		],
		objects: [
			{
				baseUrl: '/items/:id',
				objectLabel: 'Item',
				objectTable: 'item',
				selectedFields: [
					{ fieldName: 'targetItemId', fieldLabel: 'ID' },
					{ fieldName: 'targetItemDescription', fieldLabel: 'Description' },
				],
			},
		],
	};
